import { appData } from '@/mocks/homeData';

export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="section-container">
        <h2 className="section-title">移动客户端</h2>
        <p className="section-subtitle">随时随地，追剧不停，移动端完美适配体验</p>

        <div className="bg-gradient-to-br from-background-100 to-accent-50 rounded-2xl border border-background-200/70 p-8 md:p-12">
          <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-14">
            <div className="flex-1 text-center lg:text-left">
              <h3 className="text-2xl md:text-3xl font-heading text-foreground-950">
                {appData.title}
              </h3>
              <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed max-w-lg mx-auto lg:mx-0">
                {appData.description}
              </p>

              <div className="grid grid-cols-2 gap-2 mt-6 max-w-sm mx-auto lg:mx-0">
                {appData.features.map((feature) => (
                  <div key={feature} className="flex items-center gap-2 text-sm text-foreground-700">
                    <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                      <i className="ri-check-line text-primary-500"></i>
                    </div>
                    {feature}
                  </div>
                ))}
              </div>

              <a
                href="#hero"
                className="inline-flex items-center gap-2 mt-6 px-5 py-2.5 bg-primary-500 text-background-50 rounded-full text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-smartphone-line"></i>
                立即体验
              </a>
            </div>

            <div className="flex-shrink-0">
              <div className="relative w-48 md:w-56 aspect-[3/4] rounded-xl overflow-hidden border-4 border-background-50 shadow-lg">
                <img
                  src={appData.image}
                  alt={appData.alt}
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}